import React, { useEffect } from "react";
import "react-responsive-modal/styles.css";
import Modal from "react-responsive-modal";
import { useDispatch, useSelector } from "react-redux";

import { toggle_toast } from "redux/actions/modal";
import { translate } from "redux/actions/main";
import { useBackgroundAssets } from "helper";

const errCode = {
  NOT_LOGIN: "Not Login",
  TOAST_EVENTOVER: "Event ended",
  TOAST_EVENT_CLOSED_AWHILE: "The event is closed temporary",
  TOAST_EVENT_END: "Event ended",
  TOAST_EVENT_NOTOPEN: "Event hasn't started",
  TOAST_LOGIN_FAILED: "Login failed",
  TOAST_WRONG_REGION: "This event is not available for your region",
  REGION_ERROR: "Error region",
  ParameterAbnormal: "ParameterAbnormal",
  AccountNotFoundError: "Account not found",
  T_P_WRONG_ACCOUNT: "Account not found",
  T_P_MAINTAINCE: "Under Maintenance",
  VISITOR_NOT_ALLOWED: "Visitor not allowed",
  T_P_SERVER_BUSY: "Please try again later",
  TOAST_SERVER_BUSY: "Please try again later",
};

export const Toast = () => {
  const dispatch = useDispatch();
  const { toast_open, toast_msg } = useSelector((state) => state.modal);
  const { transify } = useSelector((state) => state.main);
  const t = (key) => dispatch(translate(key));

  useEffect(() => {
    if (errCode[toast_msg]) return;
    const closeTimer = setTimeout(() => {
      dispatch(toggle_toast(false, ""));
    }, 2000);

    return () => clearTimeout(closeTimer);
  }, [dispatch, toast_msg]);

  return (
    <Modal
      classNames={{
        modal: "toast uppercase",
      }}
      open={toast_open}
      animationDuration={500}
      center
      focusTrapped={false}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      blockScroll={false}
      showCloseIcon={false}
      styles={{
        modal: useBackgroundAssets("toast"),
      }}
    >
      <span>
        {transify[toast_msg] ? t(toast_msg) : errCode[toast_msg] ?? toast_msg}
      </span>
    </Modal>
  );
};
